import { WorkOrderStatus } from '@xbcb/work-order-types';

// Statuses for which a CuDe is still actively being worked and should open
// directly in edit mode. Terminal states (COMPLETED, CANCELED, REPLACED) and
// BLOCKED are excluded; those are edited only via the explicit Edit button.
const EDITABLE_ON_OPEN_STATUSES: ReadonlySet<WorkOrderStatus> = new Set([
  WorkOrderStatus.NOT_STARTED,
  WorkOrderStatus.READY,
  WorkOrderStatus.IN_PROGRESS,
]);

// A CuDe auto-opens in draft (editable) mode only in stages where CuDe editing
// is enabled (non-prod) and while the work order is still actively workable.
export const getCustomsDeclarationDraftEditMode = ({
  status,
  isEditableStage,
}: {
  status?: WorkOrderStatus | null;
  isEditableStage: boolean;
}): boolean =>
  isEditableStage && !!status && EDITABLE_ON_OPEN_STATUSES.has(status);
